module.exports = __webpack_public_path__ + "img/myvic.0f0eebbe.jpg";